<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.investor") }}</p>
    </div>
    <!-- <div class="ml-auto md:block">
            <vs-button color="success" icon="icon-search" @click="data_hide = !data_hide" icon-pack="feather">Search</vs-button>
        </div> -->
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            placeholder="Id"
            icon-no-border
            label="Id"
            v-model="id"
            id="text-box-val-id"
            @input="clearInput"
          />
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-mail"
            placeholder="Email"
            icon-no-border
            label="Email"
            v-model="email"
            id="text-box-val-email"
            @input="clearInput"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2" @click="getAllTeacher()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" search stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.id") }}</vs-th>
          <vs-th>{{ $t("labels.name") }}</vs-th>
          <vs-th>{{ $t("labels.email") }}</vs-th>
          <vs-th>{{ $t("labels.Contact") }}</vs-th>
          <vs-th>{{ $t("labels.amount") }}</vs-th>
          <vs-th>{{ $t("labels.reason") }}</vs-th>
          <vs-th>{{ $t("labels.city") }}</vs-th>
          <vs-th>{{ $t("labels.state") }}</vs-th>
          <vs-th>{{ $t("labels.referral_total") }}</vs-th>
          <vs-th>{{ $t("labels.referred_by") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].sr_no }}
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name | upper }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].information">
              {{ data[indextr].information }}
            </vs-td>

            <vs-td :data="data[indextr].amount">
              {{ data[indextr].amount }}
            </vs-td>

            <vs-td :data="data[indextr].reason">
              {{ data[indextr].reason }}
            </vs-td>

            <vs-td :data="data[indextr].location.city">
              {{ data[indextr].location.city | upper }}
            </vs-td>

            <vs-td :data="data[indextr].location.state">
              {{ data[indextr].location.state | upper }}
            </vs-td>
            <vs-td :data="data[indextr].total_refered">
              {{ data[indextr].total_refered }}
            </vs-td>
            <vs-td :data="data[indextr].referred_name">
              {{ data[indextr].referred_name | upper }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    id: "",
    email: "",
    classes: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllTeacher();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllTeacher();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllTeacher();
      }
    },
  },
  methods: {
    getAllTeacher() {
      let input = {
        id: this.id,
        email: this.email,
        classes: this.classes,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("admin/getInvestors", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.user;
          console.log(this.users);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.id = ""), (this.email = ""), (this.classes = "");
    },
    ClassDetails(id) {
      this.$router.push({ name: "ClassById", params: { id: id } });
    },
    clearInput() {
      let email = document.getElementById("text-box-val-email").value;
      if (email == "") {
        this.getAllKYC();
      }
      let id = document.getElementById("text-box-val-id").value;
      if (id == "") {
        this.getAllKYC();
      }
    },
  },
  mounted() {
    this.getAllTeacher();
  },
};
</script>

<style lang="scss" scoped>
</style>